import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';

//import { OrderComponent } from './order.component';
import { OrderAddComponent } from './order-add/order-add.component';
import { OrderListComponent } from './order-list/order-list.component';
import { OrderViewComponent } from './order-view/order-view.component';
import { OrderEntryComponent } from './components/order-entry.component';
import { OrderEntryArrayComponent } from './components/order-entry-array.component';
import { SharedModule } from '../shared/shared.module';
import { DeleteOrderDialogComponent } from './components/delete-order-dialog/delete-order-dialog.component';

@NgModule({
  entryComponents: [DeleteOrderDialogComponent],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    SharedModule,
    FormsModule
  ],
  declarations: [OrderAddComponent,
    OrderListComponent,
    OrderViewComponent,
    OrderEntryComponent,
    OrderEntryArrayComponent,
    DeleteOrderDialogComponent,
  ]
})

export class OrderModule { }



// WEBPACK FOOTER //
// ./src/app/order/order.module.ts